import './scripts/components/industry-solutions.js'
import './scripts/components/tabbed-content.js'
import './scripts/components/hero-dropdown.js'

import './scripts/animation.js'

import './scripts/widgets/news-block-api.js';
import './scripts/widgets/video-player.js';
import './scripts/widgets/carousel.js'
import './scripts/widgets/media-gallery';
import './scripts/widgets/wistia-control';
import './scripts/widgets/social-share';
import "./scripts/widgets/reading-progress";
import "./scripts/widgets/hero-banner-accordion";
import './scripts/widgets/resource-page-filter-nav';

import './scripts/global/mega-menu.js';
import './scripts/global/hero.js';
import './scripts/global/search-autosuggest.js';
import './scripts/global/smooth-anchor-scroll';
import './scripts/global/lazy';
import './scripts/global/promoClick';
import './scripts/global/summitUTMs';
import './scripts/global/product-icons';
import './scripts/global/search.js';
import './scripts/global/glossary.js';

import './scripts/pages/postid-specific.js';
import './scripts/pages/home-news-api.js';

import './scripts/blocks/harmony-table.js';
import './scripts/blocks/hero-banner-accordian.js';
import './scripts/blocks/events-agenda.js';
import './scripts/blocks/executive-grid';
import './scripts/blocks/ontario-mts-calculator';
import './scripts/blocks/rollover-tile-grid';
import './scripts/blocks/olympus-pie-chart';

// GSAP and tiny-slider make up about half of the bundle but only a few blocks use them, so those
// modules are split into their own chunks and only fetched when one of their blocks is on the page.
// Module scripts run once the document has been parsed, so every block is already in the DOM here.
const lazyModules = [
	['.js-tiny-carousel', () => import('./scripts/widgets/tiny-carousel.js')],
	['.circular-progress', () => import('./scripts/animate/circular-progress.js')],
	['.animated-icon-block', () => import('./scripts/animate/animated-icons.js')],
	['.vertical-timeline-images, .vertical-timeline-steps', () => import('./scripts/animate/vertical-timeline.js')],
	['.js-image-panel', () => import('./scripts/animate/contentImageScrollAnimate.js')],
];

lazyModules.forEach(([selector, load]) => {
	if (document.querySelector(selector)) {
		load();
	}
});
